$(function () {
  var passSave = sessionStorage.getItem('passGet'); //一時保存されていたパスワードを取得
  if (passSave) {
    $('#password').val(passSave);
  }  
  $('#submit').on('click', function () {
    console.log('Submit');
    onSubmit();
  });
  $('#password').on('keypress', function (e) {
    if (e.keyCode === 13) {  //Enterキーを押したら
      console.log('Enter');
      onSubmit();
      console.log('Submit');
      return false;  
    }
  });
  function onSubmit() {
    var pass = $('#password').val(); // #passwordのvalueの値を取得
    pass = pass.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
    if (pass === 'f106') {　// if(もしも)passが「test」なら
      sessionStorage.setItem('passGet', pass); //パスワードを一時保存しておく
      location.href = '../limited/'; // 限定ページのリンク先を追加
    } else { // else（偽ならば）以下の処理
      alert('パスワードが間違っています。'); // パスワードが間違っています。とalert
    }
    return false;
  }
});

